import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import BondFilterFields from "./BondFilterFields";

/** @param {{ variant: 'archive' | 'lawFirm' | 'bondArchives' }} props */
export default function BondFilterDialog({
  open,
  onClose,
  variant,
  filters,
  onArchiveFiltersChange,
  onLawFirmFiltersChange,
  onFiltersChange,
  bondTypes,
  availableSubcategories,
  bondNumberOptionsArchive,
  bondNumberOptionsLawFirm,
  availablePrincipals,
  availableEstates,
  principalFilterOptions,
  estateFilterOptions,
  lawFirms,
  attorneys,
  professionalGuardians,
  internalUsers,
  statusOptions,
  lawFirmStatusOptions,
  archiveStatusOptions,
  capitalizeFirst,
  clearFilters,
  applyFilters,
}) {
  const compactActions = variant === "archive" || variant === "bondArchives";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Apply Filters</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <BondFilterFields
          variant={variant}
          filters={filters}
          onArchiveFiltersChange={onArchiveFiltersChange}
          onLawFirmFiltersChange={onLawFirmFiltersChange}
          onFiltersChange={onFiltersChange}
          bondTypes={bondTypes}
          availableSubcategories={availableSubcategories}
          bondNumberOptionsArchive={bondNumberOptionsArchive}
          bondNumberOptionsLawFirm={bondNumberOptionsLawFirm}
          availablePrincipals={availablePrincipals}
          availableEstates={availableEstates}
          principalFilterOptions={principalFilterOptions}
          estateFilterOptions={estateFilterOptions}
          lawFirms={lawFirms}
          attorneys={attorneys}
          professionalGuardians={professionalGuardians}
          internalUsers={internalUsers}
          lawFirmStatusOptions={lawFirmStatusOptions}
          archiveStatusOptions={archiveStatusOptions}
          capitalizeFirst={capitalizeFirst}
          statusOptions={statusOptions}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={clearFilters}>
          {compactActions ? "Clear" : "Clear Filters"}
        </Button>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={applyFilters}>
          {compactActions ? "Apply" : "Apply Filters"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BondFilterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["archive", "lawFirm", "bondArchives"]).isRequired,
  filters: PropTypes.object.isRequired,
  onArchiveFiltersChange: PropTypes.func,
  onLawFirmFiltersChange: PropTypes.func,
  onFiltersChange: PropTypes.func,
  bondTypes: PropTypes.array.isRequired,
  availableSubcategories: PropTypes.array.isRequired,
  bondNumberOptionsArchive: PropTypes.array.isRequired,
  bondNumberOptionsLawFirm: PropTypes.array.isRequired,
  availablePrincipals: PropTypes.array.isRequired,
  availableEstates: PropTypes.array.isRequired,
  principalFilterOptions: PropTypes.array.isRequired,
  estateFilterOptions: PropTypes.array.isRequired,
  lawFirms: PropTypes.array.isRequired,
  attorneys: PropTypes.array.isRequired,
  professionalGuardians: PropTypes.array.isRequired,
  internalUsers: PropTypes.array,
  statusOptions: PropTypes.arrayOf(PropTypes.string),
  lawFirmStatusOptions: PropTypes.array.isRequired,
  archiveStatusOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  capitalizeFirst: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
};
